var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawRealTimeAnalyticsReYliv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 393,
    height: 342.513,
    viewBox: "0 0 393 342.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_real_time_analytics_re_yliv",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_338",
    "data-name": "Trazado 338",
    d: "M577.281,724.437a.685.685,0,0,0,.5-1.187l-.047-.187.019-.045a1.838,1.838,0,0,1,3.391.013,16.323,16.323,0,0,1,1.435,4.086,5.433,5.433,0,0,1-.1,1.87,21.8,21.8,0,0,0,1.984-9.056,21.071,21.071,0,0,0-.13-2.348q-.108-.959-.3-1.9a22.06,22.06,0,0,0-4.374-9.349,5.869,5.869,0,0,1-2.442-2.533,4.482,4.482,0,0,1-.407-1.224,5.524,5.524,0,0,0,.359-1.906c.166-.251.462-.376.643-.622.9-1.22,2.139-1.007,2.786.651,1.382.7,1.4,1.855.547,2.967-.54.708-.614,1.666-1.087,2.424.049.062.1.123.148.185a22.21,22.21,0,0,1,2.317,3.671,9.23,9.23,0,0,1,.551-4.287,15.465,15.465,0,0,1,2.386-3.444,1.894,1.894,0,0,1,3.374.93l.005.049q-.194.109-.38.232a.929.929,0,0,0,.374,1.69l.019,0a9.265,9.265,0,0,1-.244,1.382c1.117,4.319-1.294,5.892-4.737,5.962-.076.039-.15.078-.226.115a22.662,22.662,0,0,1,1.22,5.74,21.485,21.485,0,0,1-.016,3.47l.006-.041a5.679,5.679,0,0,1,1.939-3.279c1.492-1.226,3.6-1.677,5.209-2.662a1.066,1.066,0,0,1,1.632,1.037l-.007.043a6.224,6.224,0,0,0-.7.337q-.194.109-.38.232a.929.929,0,0,0,.374,1.69l.019,0,.039.006a9.247,9.247,0,0,1-1.7,2.664c-.7,3.77-3.7,4.128-6.905,3.03h0a22.654,22.654,0,0,1-1.522,4.443h-5.436c-.02-.06-.037-.123-.055-.183a6.179,6.179,0,0,0,1.5-.09c-.4-.495-.807-.994-1.21-1.489a.328.328,0,0,1-.025-.029c-.2-.253-.411-.5-.616-.758h0a9.04,9.04,0,0,1,.265-2.3Z",
    transform: "translate(-393.361 -387.722)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_339",
    "data-name": "Trazado 339",
    d: "M324.27,724.437a.685.685,0,0,1-.5-1.187l.047-.187-.019-.045a1.838,1.838,0,0,0-3.391.013,16.328,16.328,0,0,0-1.435,4.086,5.438,5.438,0,0,0,.1,1.87,21.805,21.805,0,0,1-1.984-9.056,21.05,21.05,0,0,1,.131-2.348q.108-.959.3-1.9a22.059,22.059,0,0,1,4.374-9.349,5.869,5.869,0,0,0,2.441-2.533,4.476,4.476,0,0,0,.407-1.224,5.526,5.526,0,0,1-.358-1.906c-.166-.251-.462-.376-.643-.622-.9-1.22-2.139-1.007-2.786.651-1.382.7-1.4,1.855-.548,2.967.54.708.614,1.666,1.087,2.424-.049.062-.1.123-.148.185a22.2,22.2,0,0,0-2.317,3.671,9.228,9.228,0,0,0-.551-4.287,15.461,15.461,0,0,0-2.386-3.444,1.894,1.894,0,0,0-3.374.93l-.005.049q.194.109.38.232a.929.929,0,0,1-.374,1.69l-.019,0a9.238,9.238,0,0,0,.244,1.382c-1.117,4.319,1.294,5.892,4.737,5.962.076.039.15.078.226.115a22.663,22.663,0,0,0-1.22,5.74,21.492,21.492,0,0,0,.016,3.47l-.006-.041a5.68,5.68,0,0,0-1.939-3.279c-1.492-1.226-3.6-1.677-5.209-2.662a1.066,1.066,0,0,0-1.632,1.037l.007.043a6.23,6.23,0,0,1,.7.337q.194.109.38.232a.929.929,0,0,1-.374,1.69l-.019,0-.039.006a9.246,9.246,0,0,0,1.7,2.664c.7,3.77,3.7,4.128,6.905,3.03h0a22.661,22.661,0,0,0,1.522,4.443h5.436c.019-.06.037-.123.055-.183a6.179,6.179,0,0,1-1.5-.09c.4-.495.807-.994,1.21-1.489a.35.35,0,0,0,.025-.029c.2-.253.411-.5.616-.758h0a9.051,9.051,0,0,0-.265-2.3Z",
    transform: "translate(-275.799 -387.722)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_340",
    "data-name": "Trazado 340",
    d: "M447.77,203.514c1.1-2.214,2.858-4.053,3.933-6.279s1.284-5.206-.507-6.91c-1.521-1.447-3.9-1.467-5.723-2.515-4.634-2.67-4.629-11.151-9.927-11.884-2.576-.356-4.907,1.576-6.465,3.659s-2.8,4.514-4.957,5.963c-2.445,1.641-5.605,1.712-8.32,2.852-5.2,2.185-7.934,7.8-10.215,12.966-1.47,3.326-2.973,6.914-2.291,10.486-1.482.922-.822,3.4.658,4.33s3.338.906,5.037,1.307a11.77,11.77,0,0,1,7.881,7.084,27.365,27.365,0,0,1,1.51,8.408l1.085,14.848c.161,2.2.372,4.542,1.712,6.3s4.243,2.49,5.749.876c1.44-1.542.791-3.984.762-6.094s1.878-4.737,3.676-3.633l.634-1.439a22.7,22.7,0,0,0,14.972-19.519C447.435,217.309,444.648,209.8,447.77,203.514Z",
    transform: "translate(-317.139 -158.901)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_341",
    "data-name": "Trazado 341",
    d: "M484.005,300.068a2.858,2.858,0,0,0-1.64-4.921l.007.238a4.916,4.916,0,0,1-2.55.67,7.722,7.722,0,0,0-2.624.416,2.211,2.211,0,0,0-1.455,2.035,2.147,2.147,0,0,0,1.158,1.613,6.344,6.344,0,0,0,1.969.6C480.635,301.048,482.7,301.3,484.005,300.068Z",
    transform: "translate(-349.176 -211.043)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_342",
    "data-name": "Trazado 342",
    d: "M546.7,221.166a6.494,6.494,0,0,0,1.842-1.908,2.215,2.215,0,0,0-.144-2.5,2.967,2.967,0,0,0-2.008-.725,15.622,15.622,0,0,0-5.918.7l5.882,5.212Z",
    transform: "translate(-377.476 -176.436)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_343",
    "data-name": "Trazado 343",
    d: "M532.061,227.508c.793.875.54,2.232.315,3.391s-.253,2.607.744,3.239a2.164,2.164,0,0,0,2.708-.7,6.235,6.235,0,0,0,1-2.866,20.026,20.026,0,0,0,.418-4.523,6.974,6.974,0,0,0-1.536-4.2,4.944,4.944,0,0,0-5.6-1.309l.911-.045a8.892,8.892,0,0,0-1.482,2.844,3.021,3.021,0,0,0,.749,2.974C530.827,226.78,531.58,226.977,532.061,227.508Z",
    transform: "translate(-372.641 -178.26)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_344",
    "data-name": "Trazado 344",
    d: "M612.337,206.759l.162-.5a3.415,3.415,0,0,0-1.536,4.015A3.732,3.732,0,0,0,612.337,206.759Z",
    transform: "translate(-408.219 -172.182)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_345",
    "data-name": "Trazado 345",
    d: "M596.641,213.862a6.345,6.345,0,0,0,3.171-4.746,3.491,3.491,0,0,0-.205-1.813,1.873,1.873,0,0,0-1.364-1.127l-.369.581c-.529-.455-1.418.013-1.64.675a3.612,3.612,0,0,0,.172,2.054,2.708,2.708,0,0,1-.032,2.038,7.328,7.328,0,0,1-1,1.049,1.045,1.045,0,0,0-.191,1.314C595.531,214.284,596.181,214.118,596.641,213.862Z",
    transform: "translate(-401.328 -172.146)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_346",
    "data-name": "Trazado 346",
    d: "M589.654,212.425a3.453,3.453,0,0,0,.43-1.863l-.807-.253a3.446,3.446,0,0,0-1.333.964,1.05,1.05,0,1,0,1.71,1.152Z",
    transform: "translate(-398.095 -173.952)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_347",
    "data-name": "Trazado 347",
    d: "M661.287,206.814l.219.186c.064-.014.125-.038.191-.046Z",
    transform: "translate(-430.294 -172.424)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_348",
    "data-name": "Trazado 348",
    d: "M658.073,214.039l2.222-1.8a3.708,3.708,0,0,0,.987-1.038,2.51,2.51,0,0,0-.179-2.417,6.646,6.646,0,0,0-1.519-1.642,2.747,2.747,0,0,0-2.1,2.985c.134.85.667,1.758.232,2.5-.17.289-.461.485-.657.757s-.259.7.01.9C657.371,214.513,657.784,214.272,658.073,214.039Z",
    transform: "translate(-428.373 -172.569)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_349",
    "data-name": "Trazado 349",
    d: "M661.136,223.263a1.924,1.924,0,0,0,1.488-.586,13.131,13.131,0,0,0,2.571-2.825l-5,1.584.52.608C660.253,222.345,660.6,223.159,661.136,223.263Z",
    transform: "translate(-429.817 -178.125)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_350",
    "data-name": "Trazado 350",
    d: "M670.126,228.886a1.277,1.277,0,0,0,1.319.805,1.908,1.908,0,0,0,1.36-.871,2.534,2.534,0,0,0-1.992-3.954l.46.7C671.39,226.77,669.759,227.737,670.126,228.886Z",
    transform: "translate(-434.135 -180.317)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_351",
    "data-name": "Trazado 351",
    d: "M727.021,252.188a2.6,2.6,0,0,0,3.119-.007,2.782,2.782,0,0,0,.166-4.076l-.851.475a2.167,2.167,0,0,0-2.951.586A2.363,2.363,0,0,0,727.021,252.188Z",
    transform: "translate(-458.661 -190.476)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_352",
    "data-name": "Trazado 352",
    d: "M743.04,255.276a2.522,2.522,0,0,0,1.729-1.757l-1.655-.217a3.664,3.664,0,0,0-1.564-.683,1.256,1.256,0,0,0-1.362.8,1.359,1.359,0,0,0,.464,1.242,2.521,2.521,0,0,0,2.388.612Z",
    transform: "translate(-464.782 -192.444)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_353",
    "data-name": "Trazado 353",
    d: "M733.126,262.559a1.426,1.426,0,0,0,.954,1.2,1.545,1.545,0,0,0,1.716-.266.947.947,0,0,0-.344-1.5l-1.241-.226C733.731,261.512,733.118,262.019,733.126,262.559Z",
    transform: "translate(-461.701 -196.418)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_354",
    "data-name": "Trazado 354",
    d: "M604.437,278.053l-.961-.877A3.145,3.145,0,0,0,604.437,278.053Z",
    transform: "translate(-405.02 -203.186)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_355",
    "data-name": "Trazado 355",
    d: "M592.037,258.038c.591,2.746,3.549,4.983,6.234,4.158l.142.129a6.3,6.3,0,0,1-.8-4.407,15.519,15.519,0,0,1,8.952-11.927,3.693,3.693,0,0,0,1.68-1.095c.383-.56.24-1.519-.419-1.677a1.57,1.57,0,0,0-1.024.237l-4.99,2.456a25.507,25.507,0,0,0-7.071,4.509C592.761,252.415,591.445,255.292,592.037,258.038Z",
    transform: "translate(-399.956 -188.336)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_356",
    "data-name": "Trazado 356",
    d: "M421.676,429.928a61.27,61.27,0,0,0-15.129-7.906c-3.311-1.177-6.869-2.075-10.319-1.407a12.283,12.283,0,0,0-8.69,6.937,12.864,12.864,0,0,0,.42,11.15c1.591,2.981,4.346,5.356,5.267,8.607a16.845,16.845,0,0,1,.028,6.784l-1.832,13.846c-.556,4.2-1.1,8.575.232,12.6s5.127,7.572,9.344,7.145l.836-.063c-2.79-1.9-3.571-5.824-2.741-9.094s2.939-6.042,5-8.715l18.324-23.794c2.471-3.209,5.085-7.175,3.767-11.005C425.432,432.836,423.548,431.269,421.676,429.928Z",
    transform: "translate(-310.146 -265.797)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_357",
    "data-name": "Trazado 357",
    d: "M320.763,345.306a1.548,1.548,0,0,0-1.636.8,10.964,10.964,0,0,1-1.032,1.659,2.8,2.8,0,0,1-3.712-.116,5.893,5.893,0,0,1-1.67-3.65,5.826,5.826,0,0,1,.935-4.674c1.1-1.278,2.913-1.621,4.58-1.887,1.722-.274,3.651-.5,5.061.522.889.645,1.406,1.687,2.229,2.414s2.287,1,2.907.1a2.232,2.232,0,0,0-.03-2.067,5.06,5.06,0,0,1-.614-2.047A3.31,3.31,0,0,1,329.442,334a7.644,7.644,0,0,0,2.281-1.9c.661-1.034.591-2.366,1-3.523.992-2.8,4.534-4.045,5.565-6.83a2.633,2.633,0,0,0,.079-1.847c-.432-1.109-1.6-.892-1.67-2.248a3.65,3.65,0,0,1,2.113-3.111,11.838,11.838,0,0,1,4.972-.732c1.689-.045,3.509-.27,4.749-1.418a4.093,4.093,0,0,0-.435-6.089c-.924-.638-2.091-.86-2.99-1.532-1.119-.838-1.649-2.233-2.521-3.326a12.791,12.791,0,0,0-2.469-2.186l-2.244-1.665a11.963,11.963,0,0,0-4.406-2.39,4.084,4.084,0,0,0-4.43,1.617,5,5,0,0,0-.52,2.1,30.283,30.283,0,0,0,.214,5.152l.408,4.125c.122,1.233-.009,2.858-1.205,3.177-2.654.71-1.759-3.215-2.347-4.417-.9-1.84-5.041-2.724-6.811-3.491a6.346,6.346,0,0,1-2.939-2.011,4.43,4.43,0,0,1-.009-4.3,18.106,18.106,0,0,1,2.677-3.6c.983-1.17,1.878-2.411,2.772-3.651l3.11-4.313c1.33-1.844,2.728-4.094,1.972-6.239a1.678,1.678,0,0,0-3.072.37c-.331,1.158.552,2.636-.293,3.493a1.584,1.584,0,0,1-2.032-.038,4.616,4.616,0,0,1-1.215-1.837c-1.024-2.275-2.021-4.563-3.072-6.826-.332-.715-.679-1.94-1.685-1.819-.874.1-1.346,1.378-1.315,2.117a8.237,8.237,0,0,0,1.093,3.013,3.586,3.586,0,0,1,.273,3.1c-.632,1.208-2.232,1.479-3.594,1.439a16.852,16.852,0,0,1-7.357-1.941l-.178,3.787-5.426-2.271-1.054-.441c-1.526-.639-3.053-1.278-4.624-1.8-.892-.294-1.8-.549-2.7-.8l-1.648-.465a8.646,8.646,0,0,0-3.382-.482,12.87,12.87,0,0,0-3.4,1.284c-2.489,1.08-5.708-.007-8.375-.026a11.2,11.2,0,0,0-18.813.521,22.407,22.407,0,0,0-1.25,2.514l-1.086,2.433a7.873,7.873,0,0,0-.969,3.742,2.7,2.7,0,0,0,2.4,2.614c-3.072,1.391-3.711,6.257-1.1,8.394a24.582,24.582,0,0,1,2.258,1.649,3.541,3.541,0,0,1-2.66,6,8.624,8.624,0,0,0,10.251-3.211c1.115-1.746,1.6-3.928,3.117-5.339,2.009-1.869,5.328-1.724,7.646-.254a13.194,13.194,0,0,1,4.792,6.523c1.322,3.344,2.167,7.166,4.983,9.4,1.361,1.082,3.085,1.69,4.288,2.945,1.713,1.787,2.01,4.485,1.971,6.961s-.305,5.044.6,7.35,3.487,4.2,5.806,3.333a9.235,9.235,0,0,0,3.866,10.786l-1.267-7.86c2.105.593,3.47,2.635,4.258,4.675s1.2,4.246,2.347,6.112c1.8,2.937,5.056,4.2,8.369,4.191,3.579-.012,4.938-1.719,7.3-4.232a3.85,3.85,0,0,0,1.047-1.571A1.322,1.322,0,0,0,320.763,345.306Z",
    transform: "translate(-250.858 -201.225)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_358",
    "data-name": "Trazado 358",
    d: "M388.411,400.75l-6-.943,3.147,1.892a11.379,11.379,0,0,0,2.826,1.361,3.838,3.838,0,0,0,3.04-.32l-.256-.49C390.762,401.23,389.495,400.921,388.411,400.75Z",
    transform: "translate(-308.371 -256.799)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_359",
    "data-name": "Trazado 359",
    d: "M384.1,416.948l.014-.035a1.175,1.175,0,0,0-1.193-.553,4.363,4.363,0,0,1-1.4.023,1.979,1.979,0,0,1-1.2-1.364c-.2-.6-.258-1.238-.484-1.827a2.681,2.681,0,0,0-2.167-1.767,1.873,1.873,0,0,0-2.014,1.69,3.128,3.128,0,0,0,.467,1.421l.647,1.245a8.363,8.363,0,0,0,.626,1.071,4.183,4.183,0,0,0,6.7.1Z",
    transform: "translate(-305.422 -261.876)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_360",
    "data-name": "Trazado 360",
    d: "M366.214,213c1.523.9,3.431,1.517,4.155,3.131l.418.135-1.366,1.7a3.941,3.941,0,0,0-1.142,2.377,2.9,2.9,0,0,0,2.409,2.461,5.28,5.28,0,0,0,6.1-3.6c.143-.521.2-1.062.327-1.587a12.912,12.912,0,0,1,1.635-3.514l12.136-20.418a3.249,3.249,0,0,0,.644-2.772,2.178,2.178,0,0,0-2.15-1.154,6.388,6.388,0,0,0-2.448.823,4.168,4.168,0,0,0-3.261-2.09,12.308,12.308,0,0,0-4,.349,24.637,24.637,0,0,0-8.4,2.884c-1.423.719-2.988,1.608-3.4,3.147-.508,1.894,1.129,3.825,3.013,4.369s3.895.087,5.8-.371a4.39,4.39,0,0,1-7.338,4.142c-1.367-1.331-2.036-3.641-3.913-3.985s-3.358,1.653-3.77,3.509A9.972,9.972,0,0,0,366.214,213Z",
    transform: "translate(-299.218 -164.399)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_361",
    "data-name": "Trazado 361",
    d: "M395.291,278.152a35.877,35.877,0,0,0-3.529-7.243,21.641,21.641,0,0,0-4.012-4.835,15.5,15.5,0,0,0-4.852-2.842,8.388,8.388,0,0,0-5.39-.363,4.442,4.442,0,0,0-3.192,4.024c.039,2.028,1.813,3.614,3.663,4.447s3.906,1.2,5.651,2.23a8.47,8.47,0,0,1,4.068,6.838l.439.727a8.785,8.785,0,0,0-2.741,1.492,2.981,2.981,0,0,0-1.041,2.8c.3,1.228,1.559,1.933,2.693,2.494l6.285,3.113c-1.067-3.181,2.426-6.141,2.619-9.49A8.773,8.773,0,0,0,395.291,278.152Z",
    transform: "translate(-304.833 -196.8)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_362",
    "data-name": "Trazado 362",
    d: "M317.1,267.575c1.271.987,3.225.525,4.389-.585a10.247,10.247,0,0,0,2.26-4.211,16.259,16.259,0,0,0,.054,4.527,5.484,5.484,0,0,0,2.386,3.709,6.43,6.43,0,0,0,1.836.669,15.459,15.459,0,0,0,8.969-.641l.026-.978c-1.437.164-2.524-1.412-2.619-2.855s.429-2.858.475-4.3-.651-3.134-2.074-3.392a2.751,2.751,0,0,1-3.5,3.775c-1.647-.67-2.246-2.677-3.519-3.918a5.339,5.339,0,0,0-5.859-.824,7.266,7.266,0,0,0-3.766,4.789C315.777,264.821,315.892,266.634,317.1,267.575Z",
    transform: "translate(-279.323 -194.812)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_363",
    "data-name": "Trazado 363",
    d: "M376.862,252.321l.059-.1a3.035,3.035,0,0,0-2.528-1.778,16.428,16.428,0,0,0-3.244.107,4.7,4.7,0,0,1-3.11-.685,11.9,11.9,0,0,1-1.75-2.13,2.278,2.278,0,0,0-2.4-.953,1.88,1.88,0,0,0-.726,2.56,4.526,4.526,0,0,0,2.277,1.858,17.561,17.561,0,0,0,11.427,1.115Z",
    transform: "translate(-299.859 -189.857)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_364",
    "data-name": "Trazado 364",
    d: "M365.532,261.954a1.427,1.427,0,0,0,1.59,2.367l.313.309a2.228,2.228,0,0,0,.056-2.415A1.48,1.48,0,0,0,365.532,261.954Z",
    transform: "translate(-300.737 -196.419)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_365",
    "data-name": "Trazado 365",
    d: "M357.683,265.929a1.321,1.321,0,0,0-.824-1.247,1.265,1.265,0,0,0-1.468,1.087,2.523,2.523,0,0,0,.661,1.9,1.741,1.741,0,0,0,1.209.76c.491.016.992-.5.793-.947l-.75-.015A3.873,3.873,0,0,0,357.683,265.929Z",
    transform: "translate(-296.556 -197.716)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_366",
    "data-name": "Trazado 366",
    d: "M332.4,249.531l.826.67a9.91,9.91,0,0,0,1.539,1.093,4.216,4.216,0,0,0,3.136.384,3.228,3.228,0,0,0,2.207-2.178,5.725,5.725,0,0,0-.734-3.7,2.247,2.247,0,0,0-.578-.881.77.77,0,0,0-.974-.038.964.964,0,0,0-.157.926,2.524,2.524,0,0,1,.152.965c-.052.324-.392.63-.692.5l-.048,1.1c-1.43-.724-2.186-2.65-3.778-2.839a1.964,1.964,0,0,0-1.962,2.883,3.946,3.946,0,0,0,1.06,1.119Z",
    transform: "translate(-285.943 -188.998)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_367",
    "data-name": "Trazado 367",
    d: "M325.159,242.365a2.178,2.178,0,0,0,.928-2.075,1.339,1.339,0,0,0-1.818-.97,2.156,2.156,0,0,0-.81,1.243l-1.131,3.19.633-.461a6.407,6.407,0,0,0,2.2-.927Z",
    transform: "translate(-282.105 -186.592)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_368",
    "data-name": "Trazado 368",
    d: "M338.79,231.7a1.246,1.246,0,0,0-.385-1.871l-.792-.074a1.189,1.189,0,1,0,1.177,1.946Z",
    transform: "translate(-288.394 -182.455)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_369",
    "data-name": "Trazado 369",
    d: "M351.363,230.618c.739.354,1.675.691,2.318.183a1.462,1.462,0,0,0,.448-1.393,3.542,3.542,0,0,0-.654-1.377,13.226,13.226,0,0,0-3.678-3.552l-.357.464c-.5,1.3-.981,2.809-.285,4.011A4.733,4.733,0,0,0,351.363,230.618Z",
    transform: "translate(-293.68 -180.148)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_370",
    "data-name": "Trazado 370",
    d: "M363.132,237.416l1.382.625a1.3,1.3,0,0,0-1.382-.625Z",
    transform: "translate(-299.944 -185.792)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_371",
    "data-name": "Trazado 371",
    d: "M355.745,245.158l-.653.215a4.12,4.12,0,0,0-.056,3.116c.163.655.516,1.462,1.19,1.432.657-.029.947-.825,1.073-1.47a4.437,4.437,0,0,0,.062-2.15A1.523,1.523,0,0,0,355.745,245.158Z",
    transform: "translate(-296.281 -189.185)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_372",
    "data-name": "Trazado 372",
    d: "M337.923,239.053l.483.195a.52.52,0,1,0-.483-.195Z",
    transform: "translate(-288.874 -186.152)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_373",
    "data-name": "Trazado 373",
    d: "M380.182,304.526a1.469,1.469,0,0,0-1.344,1.98,1.773,1.773,0,0,0,2.835.165,2.224,2.224,0,0,0-.574-3.221Z",
    transform: "translate(-306.77 -214.673)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_374",
    "data-name": "Trazado 374",
    d: "M422.274,348.357a1.471,1.471,0,0,0-1.031,1.84l1.357.094,1.379-.692a1.471,1.471,0,0,0-1.7-1.242Z",
    transform: "translate(-325.323 -234.297)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_375",
    "data-name": "Trazado 375",
    d: "M412.406,350.777a2.8,2.8,0,0,0-1.175,2.455,2.243,2.243,0,0,0,1.755,1.983,1.875,1.875,0,0,0,2.119-1.437c.229-1.4-1.279-2.431-1.821-3.746Z",
    transform: "translate(-320.969 -235.038)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_376",
    "data-name": "Trazado 376",
    d: "M505.8,330.044c.143,1.054-.806,1.977-.841,3.039a2.321,2.321,0,0,0,2.586,2.118,4.089,4.089,0,0,0,2.938-2.158l.027-.118-1.835-2.074a4.6,4.6,0,0,1-1.518-2.948c.015-.559.235-1.1.222-1.658a4.015,4.015,0,0,0-.266-1.172c-.166-.494-.391-1.051-.885-1.218-.618-.209-1.242.339-1.537.921a3.643,3.643,0,0,0,.108,3.431A5.378,5.378,0,0,1,505.8,330.044Z",
    transform: "translate(-361.669 -223.575)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_377",
    "data-name": "Trazado 377",
    d: "M496.528,338.877a1.054,1.054,0,0,0,.879.056,4.6,4.6,0,0,0,1.546-.562,1.561,1.561,0,0,0,.756-1.381,1.806,1.806,0,0,0-1.471-1.366,1.582,1.582,0,0,0-1.472.225,2,2,0,0,0-.312,1.771l-.1.161C496.273,338.164,496.218,338.639,496.528,338.877Z",
    transform: "translate(-358.16 -228.7)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_378",
    "data-name": "Trazado 378",
    d: "M667.359,420.71l-.4-.987C666.781,420.17,666.848,420.626,667.359,420.71Z",
    transform: "translate(-432.735 -265.506)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_379",
    "data-name": "Trazado 379",
    d: "M677.673,272.51a18.179,18.179,0,0,1-3.809-5.186,8.4,8.4,0,0,0-6.358-4.775c-3.521-.58-7.12.338-10.684.154-5.709-.295-10.857-3.357-16.323-5.027a68.3,68.3,0,0,0-9.329-1.924l-5.446-.861c-5.951-.941-11.939-1.885-17.963-1.76-1.737.036-4.156-.486-4.017-2.218.173-2.151,4.042-1.868,4.787-3.894.461-1.253-.642-2.568-1.85-3.135s-2.6-.737-3.7-1.5-1.7-2.524-.69-3.4l-8.383,4.3c-2.323,1.191-4.919,2.74-5.329,5.318a6.163,6.163,0,0,0-3.46,2.4,3.483,3.483,0,0,0-3.066,3.067,10.167,10.167,0,0,0,.678,4.62,7.864,7.864,0,0,0-2.181-2.938,2.7,2.7,0,0,0-3.391.037c-.879.908-.674,2.432-.052,3.533s1.577,1.989,2.164,3.108c1.833,3.5-1.488,8.42-5.417,8.031l.79-10.833a7.25,7.25,0,0,0-.273-3.313,2.483,2.483,0,0,0-2.618-1.639c-1.964.439-1.8,3.315-.979,5.154s1.631,4.4-.036,5.522c-1.077.727-2.537.278-3.7-.3s-2.406-1.3-3.677-1.025-2.07,2.214-.947,2.868l-5.586-.971a3.973,3.973,0,0,1-4.972,3.172l-.548-2.273-.817-.228c.855.238-.483,3.845-1.682,6.6-1.613-.189-3.97-.226-4.238-.688-1.288-2.213-1.135-7.484-3.372-8.729q-1.683-.937-3.452-1.707a8.093,8.093,0,0,0-1.947-.639,9.052,9.052,0,0,0-4.085.631,10.48,10.48,0,0,0-7.28,5.369l-7.683,11.371a12.183,12.183,0,0,0-1.779,3.335,4.357,4.357,0,0,0,.405,3.61,2.793,2.793,0,0,0,3.271,1.118c.742-.321,1.486-1.05,2.221-.713a1.531,1.531,0,0,1,.638,1.6,4.266,4.266,0,0,0-.033,1.819,1.906,1.906,0,0,0,2.542.869,3.929,3.929,0,0,0,1.868-2.274c.885-2.271.8-4.783,1.016-7.211s.884-5.024,2.8-6.533a1.743,1.743,0,0,1,2-.348,1.433,1.433,0,0,1,.352,1.627,6.369,6.369,0,0,1-.955,1.5,8.225,8.225,0,0,0-1.353,6.419l.391.242c1.492-.387,3.489.306,5.47.971a7.121,7.121,0,0,0-3.618,2.488c-2.29,3.213-3.947,6.253-8.477,6.215-1.075-.009-2.14-.222-3.215-.224a4.2,4.2,0,0,0-2.981.993c-.815.8-1.067,2.012-1.764,2.915-.916,1.187-2.448,1.669-3.847,2.208a4.388,4.388,0,0,0-2.57,1.915,4.744,4.744,0,0,0-.2,2.536c.157,1.5.436,3.2,1.708,4.013a4.046,4.046,0,0,0,3.113.263,13.464,13.464,0,0,1,3.975-.837,4.449,4.449,0,0,1,3.911,4.327c.011,1.082-.3,2.323.412,3.133a1.916,1.916,0,0,0,2.709-.114,3.121,3.121,0,0,0,.588-2.865A9.215,9.215,0,0,0,524,309.085a3.173,3.173,0,0,1,3.651,1.688,11.959,11.959,0,0,1,.472,3.411c.151,1.144.848,2.416,2,2.482a1.614,1.614,0,0,0,1.623-1.274,11.6,11.6,0,0,0-.095-1.737,2.226,2.226,0,0,1,2.248-2.071,3.172,3.172,0,0,0,.777,3.961,6.887,6.887,0,0,0,3.128,1.02,4.745,4.745,0,0,1,2.963,1.345c1.174,1.425-.263,2.067-.486,3.275-.275,1.482.963,3.671,1.439,5.088l6.555,9.17a11.092,11.092,0,0,0,1.714,2.031,6.026,6.026,0,0,0,7.781-.281,6.671,6.671,0,0,0,1.133-7.845c-1.278-2.327-3.811-3.768-5.062-6.11a13.352,13.352,0,0,0,7.329,3.014,36.958,36.958,0,0,1,13.316,5.585,18.569,18.569,0,0,0,4.579,11.4,16.411,16.411,0,0,1,4.762-9.457c1.683-1.642,3.983-2.965,6.293-2.524s4.062,3.386,2.665,5.278l3.511.261,1.575,3.915a1.356,1.356,0,0,1,1.323-.918c1.1.165,1.864,1.185,2.906,1.561,1.965.71,4.065-1.256,4.319-3.329s-.732-4.075-1.691-5.931a11.071,11.071,0,0,0,11.376-16.8,28.191,28.191,0,0,1,7.919-5.83c2.74-1.354,5.737-2.283,8.132-4.182s4.074-5.2,2.922-8.027c-.814-2-2.855-3.357-3.466-5.428-.884-3,1.8-6.1,4.836-6.848s6.2.172,9.192,1.085c-.459-3.076,3.106-5.959,6.018-4.867l3.658-1.481c-1.414,3.117-4.477,5.1-6.729,7.676s-3.594,6.772-1.241,9.257l10.117-9.17,10.583-9.592-.505-1.484C670.886,275.133,674.48,274.085,677.673,272.51Z",
    transform: "translate(-363.65 -186.492)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_380",
    "data-name": "Trazado 380",
    d: "M497.411,366.579a1.161,1.161,0,0,0,.007,1.335,1.022,1.022,0,0,0,1.3.017,2.979,2.979,0,0,0,.825-1.142,1.858,1.858,0,0,0,1.889.989,4.645,4.645,0,0,0,2.084-.869,4.57,4.57,0,0,0,1.266-1.1,1.807,1.807,0,0,0,.318-1.591,2.741,2.741,0,0,0-.822-1.062l-2.677-2.473-.3-.091a1.706,1.706,0,0,0-2.46-.026,3.053,3.053,0,0,0-.472,2.375,4.494,4.494,0,0,1-.152,2.455C498,365.826,497.646,366.165,497.411,366.579Z",
    transform: "translate(-358.558 -239.422)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_381",
    "data-name": "Trazado 381",
    d: "M544.019,401.219a18.608,18.608,0,0,1-14.141-14.213c-.329-1.638-.478-3.429-1.568-4.7a5.728,5.728,0,0,0-4.4-1.669c-1.618,0-3.212.372-4.827.473a10.264,10.264,0,0,1-7.833-2.551,21.174,21.174,0,0,0-2.8-2.87,6.073,6.073,0,0,0-5.2-.43c-1.9.628-3.429,2.345-5.511,2.109-2.166-.246-4.675-1.011-5.524,1.84-.244.821-.161,1.722-.471,2.52-.477,1.231-1.744,1.925-2.746,2.785a11.121,11.121,0,0,0-3.452,7,33.064,33.064,0,0,0,.2,7.955,6.731,6.731,0,0,0,1.329,4.009c1.366,1.46,3.658,1.4,5.65,1.239l6.946-.573c1.248-.1,2.67-.147,3.558.736a19.706,19.706,0,0,1,1.226,1.88,2.887,2.887,0,0,0,3.522.71,5.847,5.847,0,0,0,4.411,8.662l.178.113c-1.482,2.538-3.02,5.388-2.405,8.263.527,2.465,2.568,4.44,2.9,6.938.306,2.292-.89,4.636-.361,6.887a5.7,5.7,0,0,0,5.173,4.038,9.346,9.346,0,0,0,6.439-2.353,27.76,27.76,0,0,0,4.586-5.295,10.238,10.238,0,0,0,2.016-3.8c.311-1.507-.05-3.177.683-4.529.845-1.56,2.851-2.145,3.863-3.6,1.311-1.887.539-4.456.828-6.736C537.015,410.418,544.182,406.9,544.019,401.219Z",
    transform: "translate(-353.39 -245.903)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_382",
    "data-name": "Trazado 382",
    d: "M584.544,455.622a3.285,3.285,0,0,1-1.806,1.9,4.582,4.582,0,0,0-2.05,1.7,4.046,4.046,0,0,0-.008,2.714q.67,2.8,1.577,5.546a56.468,56.468,0,0,0,3.065-6.859,9.014,9.014,0,0,0,.673-2.75,3.4,3.4,0,0,0-.925-2.6Z",
    transform: "translate(-394.95 -281.05)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_383",
    "data-name": "Trazado 383",
    d: "M668.885,434.461l-2.954-3.41a4.285,4.285,0,0,0-2.462-1.737l-.42.268,2.561,6.1a5.791,5.791,0,0,0,1.547,2.433,1.99,1.99,0,0,0,2.641-.018,1.958,1.958,0,0,0,.232-1.943,5.771,5.771,0,0,0-1.145-1.692Z",
    transform: "translate(-431.064 -269.699)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_384",
    "data-name": "Trazado 384",
    d: "M687.416,436.859a2.831,2.831,0,0,0,1.674-1.56,8.387,8.387,0,0,0,.6-2.272l.5-3.054-.22-.057a.981.981,0,0,0-1.243.345,4.874,4.874,0,0,0-.557,1.3,1.576,1.576,0,0,1-.9,1.034c-.79.239-1.539-.6-2.364-.566a1.486,1.486,0,0,0-1.291,1.325,2.881,2.881,0,0,0,.54,1.893A3.141,3.141,0,0,0,687.416,436.859Z",
    transform: "translate(-440.054 -269.921)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_385",
    "data-name": "Trazado 385",
    d: "M699.939,441.114l2.269-5.977A5.829,5.829,0,0,0,699.939,441.114Z",
    transform: "translate(-447.133 -272.245)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_386",
    "data-name": "Trazado 386",
    d: "M720.021,437.2l-.459.019a2.961,2.961,0,0,0-.025,2.621,5.909,5.909,0,0,0,1.712,2.081,12.028,12.028,0,0,0,3.777,2.109,24.037,24.037,0,0,0,6.206.956l3.6.236c.572.037,1.313-.035,1.472-.586.131-.455-.256-.883-.618-1.188a22.647,22.647,0,0,0-11.138-5.055A11.182,11.182,0,0,1,720.021,437.2Z",
    transform: "translate(-455.632 -273.145)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_387",
    "data-name": "Trazado 387",
    d: "M719.424,461.424l-2.592-2.513c-.84-.815-2.1-1.678-3.062-1.013-.554.382-.724,1.128-1.193,1.611a2.3,2.3,0,0,1-2.137.509,6.8,6.8,0,0,1-2.063-.978l-2.144-1.33-2.219-1.377-1.67,1.623c.073-.8-.992-1.317-1.729-1a2.671,2.671,0,0,0-1.33,1.9,10.4,10.4,0,0,1-.638,2.311c-.848,1.623-2.906,2.1-4.717,2.375s-3.862.655-4.831,2.208c-.807,1.294-.565,2.955-.3,4.456l1.021,5.679a3.1,3.1,0,0,0,.784,1.854c.9.791,2.285.31,3.379-.172a22.852,22.852,0,0,1,7.263-2.1,10.48,10.48,0,0,1,7.2,1.843c1.3.988,2.287,2.356,3.662,3.233a7.264,7.264,0,0,0,6.354.555,9.459,9.459,0,0,0,4.832-4.309,11.32,11.32,0,0,0-.244-11.206A22.224,22.224,0,0,0,719.424,461.424Z",
    transform: "translate(-442.212 -281.512)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_388",
    "data-name": "Trazado 388",
    d: "M738.613,506.184a1.526,1.526,0,0,0-.1,1.81,2.5,2.5,0,0,0,1.6,1.028,7.425,7.425,0,0,0,1.942.089l.02-.485a4.977,4.977,0,0,0-1.138-2.292A1.712,1.712,0,0,0,738.613,506.184Z",
    transform: "translate(-463.948 -303.135)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_389",
    "data-name": "Trazado 389",
    d: "M775.959,507.321l-.31-.113-2.212,3.333a2.366,2.366,0,0,0-.569,1.991,1.789,1.789,0,0,0,2.168.823,3.42,3.42,0,0,0,2.473-2.715A3.358,3.358,0,0,0,775.959,507.321Z",
    transform: "translate(-479.046 -303.754)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_390",
    "data-name": "Trazado 390",
    d: "M786.7,499.886l-2.035-1.618q-.041,1.126-.082,2.252H784.5a14.928,14.928,0,0,1,1.327,1.319c.476.405,1.276.59,1.683.116a1.064,1.064,0,0,0,.044-1.175A3.125,3.125,0,0,0,786.7,499.886Z",
    transform: "translate(-484.164 -299.846)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_391",
    "data-name": "Trazado 391",
    d: "M719.64,371.643a3.634,3.634,0,0,0-2.461.462,3.3,3.3,0,0,0-.568.662l-.233.327a8.984,8.984,0,0,0-.909,1.462,1.929,1.929,0,0,0-.124,1.595.925.925,0,0,0,1.365.392c.365-.338.28-.951.556-1.366a1.276,1.276,0,0,1,1.028-.491,6.752,6.752,0,0,1,1.173.133,5.662,5.662,0,0,0,5.541-8.655l-.069-.21a2.529,2.529,0,0,0-2.565,1.977c-.191,1,.214,2.151-.389,2.965A2.717,2.717,0,0,1,719.64,371.643Z",
    transform: "translate(-453.877 -241.998)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_392",
    "data-name": "Trazado 392",
    d: "M734.468,357.311l-.13-.011a6.6,6.6,0,0,0-2.166.807,1,1,0,0,0-.493.5.728.728,0,0,0,.172.67,2.148,2.148,0,0,0,.574.432,3.415,3.415,0,0,0,1.044.467,1.159,1.159,0,0,0,1.066-.275,1.54,1.54,0,0,0,.25-1.276A6.717,6.717,0,0,0,734.468,357.311Z",
    transform: "translate(-461.059 -238.215)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_393",
    "data-name": "Trazado 393",
    d: "M711.856,374.6a3.286,3.286,0,0,0,.429-1.065l.239-.879-.851-.517a4.927,4.927,0,0,0-1.114.794,1.662,1.662,0,0,0-.511,1.231,1.016,1.016,0,0,0,.836.949,1.117,1.117,0,0,0,.974-.514Z",
    transform: "translate(-451.612 -244.704)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_394",
    "data-name": "Trazado 394",
    d: "M548.3,235.8c-.337.21-.242.717-.1,1.09l.47,1.283.219-.83a1.764,1.764,0,0,0,.243-1.07C549.05,235.909,548.614,235.605,548.3,235.8Z",
    transform: "translate(-380.796 -185.071)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_395",
    "data-name": "Trazado 395",
    d: "M805.477,273.468H663.086a12.959,12.959,0,0,1-12.945-12.945V158.655a12.959,12.959,0,0,1,12.945-12.945H805.477a12.959,12.959,0,0,1,12.945,12.945V260.524a12.959,12.959,0,0,1-12.945,12.945Z",
    transform: "translate(-425.422 -145.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_396",
    "data-name": "Trazado 396",
    d: "M805.477,273.468H663.086a12.959,12.959,0,0,1-12.945-12.945V158.655a12.959,12.959,0,0,1,12.945-12.945H805.477a12.959,12.959,0,0,1,12.945,12.945V260.524a12.959,12.959,0,0,1-12.945,12.945ZM663.086,146.836a11.832,11.832,0,0,0-11.819,11.819V260.524a11.832,11.832,0,0,0,11.819,11.819H805.477A11.833,11.833,0,0,0,817.3,260.524V158.655a11.832,11.832,0,0,0-11.819-11.819Z",
    transform: "translate(-425.422 -145.711)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_397",
    "data-name": "Trazado 397",
    d: "M722.74,169.772H700.228a2.251,2.251,0,1,1,0-4.5H722.74a2.251,2.251,0,1,1,0,4.5Z",
    transform: "translate(-446.335 -154.262)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_398",
    "data-name": "Trazado 398",
    d: "M771.7,259.772H700.228a2.251,2.251,0,1,1,0-4.5H771.7a2.251,2.251,0,1,1,0,4.5Z",
    transform: "translate(-446.335 -193.609)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_211",
    "data-name": "Elipse 211",
    cx: 15.094,
    cy: 15.094,
    r: 15.094,
    transform: "translate(251.46 21.763)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_707",
    "data-name": "Rect\\xE1ngulo 707",
    width: 3.377,
    height: 1.126,
    transform: "translate(251.642 109.155)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_399",
    "data-name": "Trazado 399",
    d: "M808.627,340.783h-7.082v-1.126h7.082Zm-14.164,0h-7.082v-1.126h7.082Zm-14.164,0h-7.082v-1.126H780.3Zm-14.164,0h-7.082v-1.126h7.082Zm-14.164,0h-7.082v-1.126h7.082Zm-14.164,0h-7.082v-1.126h7.082Zm-14.164,0H716.56v-1.126h7.082Z",
    transform: "translate(-454.459 -230.502)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_708",
    "data-name": "Rect\\xE1ngulo 708",
    width: 3.377,
    height: 1.126,
    transform: "translate(361.25 109.155)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_709",
    "data-name": "Rect\\xE1ngulo 709",
    width: 2.814,
    height: 19.135,
    transform: "translate(306.144 89.238)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_710",
    "data-name": "Rect\\xE1ngulo 710",
    width: 2.814,
    height: 19.135,
    transform: "translate(334.847 89.238)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_711",
    "data-name": "Rect\\xE1ngulo 711",
    width: 2.814,
    height: 8.442,
    transform: "translate(348.917 99.932)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_712",
    "data-name": "Rect\\xE1ngulo 712",
    width: 2.814,
    height: 27.578,
    transform: "translate(320.214 80.796)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_212",
    "data-name": "Elipse 212",
    cx: 3.377,
    cy: 3.377,
    r: 3.377,
    transform: "translate(47.252 120.756)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_213",
    "data-name": "Elipse 213",
    cx: 3.377,
    cy: 3.377,
    r: 3.377,
    transform: "translate(56.256 104.434)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_214",
    "data-name": "Elipse 214",
    cx: 3.377,
    cy: 3.377,
    r: 3.377,
    transform: "translate(155.311 91.49)",
    fill: "#58b957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_400",
    "data-name": "Trazado 400",
    d: "M144.23,582.206h5.093l2.423-19.646h-7.517Z",
    transform: "translate(-63.056 -245.946)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_401",
    "data-name": "Trazado 401",
    d: "M394.771,746.042h15.663v-.2a6.1,6.1,0,0,0-6.1-6.1h0l-2.861-2.17-5.338,2.171H394.77Z",
    transform: "translate(-313.775 -404.47)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_402",
    "data-name": "Trazado 402",
    d: "M212.23,582.206h5.093l2.423-19.646h-7.517Z",
    transform: "translate(-92.785 -245.946)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_403",
    "data-name": "Trazado 403",
    d: "M462.771,746.042h15.663v-.2a6.1,6.1,0,0,0-6.1-6.1h0l-2.861-2.17-5.338,2.171H462.77Z",
    transform: "translate(-343.504 -404.47)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_404",
    "data-name": "Trazado 404",
    d: "M394.737,458.211l9.039-1.295c3.057,5.112,4.143,18.718,4.143,18.718l8.846,21.026a4.031,4.031,0,1,1-6.285,3.028l-14.524-24.473Z",
    transform: "translate(-313.761 -281.767)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_405",
    "data-name": "Trazado 405",
    d: "M397.1,414.539h0a9.634,9.634,0,0,0-7.611,12.726l1.918,5.437s-2.416,16.37,1.566,20.991l12.219-1.106s-2.234-8.259-.519-12.255c1.05-2.447.992-10.9-.043-17.776C403.844,417.306,402.351,413.727,397.1,414.539Z",
    transform: "translate(-311.228 -263.19)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_406",
    "data-name": "Trazado 406",
    d: "M438.858,502.27s9.419,9.185,7.407,11.307-6.612,5.093-2.342,5.577,6.042,1.533,2.342,2.416-3.128,3.148-3.128,3.148,5.57,26.516,1.349,43.963c0,0-2.349,47.654-3.823,51.365s-2.037,1.46-1.474,3.711,1.688-1.688.563,2.251a52.08,52.08,0,0,0-1.456,6.27l-11.01-1.688s-1.773-5.587,0-7.054,3.363-.563,1.442-3.829-2.483,1.236-1.921-3.266-1.787-28.854,1.921-41.723l-6.851-36.111L411,576s-5.77,45.666-7.644,47.276-4.689-1.2-1.875,1.61,2.765,2.33,2.814,2.814c.524,5.162-15.589-.484-15.589-.484a28.905,28.905,0,0,0,0-3.94c-.17-1.2,1.858-1.59,0-2.8s.907-.01.907-.01,4.155-33.69,7.316-43.9l3.658-49.717s.232.992,0-1.419-1.921-.722-.232-2.41,2.814-2.549,1.688-3.807-4.231-3.8-2.4-5.345,5.443-11.593,5.443-11.593l35.176.281",
    transform: "translate(-310.843 -301.595)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_407",
    "data-name": "Trazado 407",
    d: "M428.862,397.548l-6.342-7.142L412.5,391.52l-6.416,8.98h0a13.7,13.7,0,0,0-10.428,15.691c2.49,14.338,10.952,28.243,8.158,35.317-4.241,10.738-4.5,15.118,5.653,13.613s44.166-4.976,37.571-11.571-8.043-17.614-8.043-17.614l-.264-25.211a11.2,11.2,0,0,0-9.866-13.177Z",
    transform: "translate(-314.072 -252.69)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_408",
    "data-name": "Trazado 408",
    d: "M451.737,451.211l9.039-1.295c3.057,5.112,4.143,18.718,4.143,18.718l8.846,21.026a4.031,4.031,0,1,1-6.285,3.028l-14.524-24.473Z",
    transform: "translate(-338.681 -278.707)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_409",
    "data-name": "Trazado 409",
    d: "M454.1,407.539h0a9.634,9.634,0,0,0-7.611,12.726l1.918,5.437s-2.416,16.371,1.566,20.992l12.219-1.106s-2.234-8.259-.519-12.255c1.05-2.447.992-10.9-.043-17.776C460.844,410.306,459.351,406.727,454.1,407.539Z",
    transform: "translate(-336.148 -260.13)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_215",
    "data-name": "Elipse 215",
    cx: 12.113,
    cy: 12.113,
    r: 12.113,
    transform: "translate(88.566 112.875)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_410",
    "data-name": "Trazado 410",
    d: "M416.171,367.154c3.374-.845,3.488-1.809,6.862-2.655,1.074-.269,2.319-.693,2.637-1.754a2.555,2.555,0,0,0-.607-2.2,20.763,20.763,0,0,1-1.491-1.833,3.679,3.679,0,0,1,2.54-5.511c1.044-.179,2.12.1,3.17-.036,1.44-.184,3.559-5.528,2.636-6.649-.9-1.091-2.374-1.742-2.87-3.065a13.881,13.881,0,0,1-.291-2.747c-.214-1.354-2.954,2.395-2.589,1.073.895-3.241-14.241-3.752-15.817.407-.589,1.554-2.183,1.8-3.41,2.923-.8.735-2.726,3.088-3,4.356a9.191,9.191,0,0,0,.13,3.863c1.257,5.924,3.335,11.174,8.865,13.642",
    transform: "translate(-317.719 -230.308)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_411",
    "data-name": "Trazado 411",
    d: "M255.539,752.941l219.341.173a.67.67,0,1,0,0-1.34L255.539,751.6a.67.67,0,1,0,0,1.34Z",
    transform: "translate(-252.612 -410.601)",
    fill: "#cacaca"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawRealTimeAnalyticsReYliv);
export default __webpack_public_path__ + "static/media/undraw_real_time_analytics_re_yliv.e989a37e693aad5b2ae7f1efd866d05a.svg";
export { ForwardRef as ReactComponent };